import { createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  setActiveControl: ['activeControl', 'data'],
  setComplexStage: ['complex'],
})
